import { render, staticRenderFns } from "./orderDone.vue?vue&type=template&id=51d9d1ef&scoped=true"
import script from "./orderDone.vue?vue&type=script&lang=js"
export * from "./orderDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d9d1ef",
  null
  
)

export default component.exports